import { reverse } from "@reactivated";

import {
    IModularConfiguratorPromoCard,
    IModularConfiguratorUpsellInfoModal,
    ModularConfiguratorPromoCards,
    ModularConfiguratorUpsellInfoModals,
} from "../apps/configurator/models";
import { IProductID, isoProductID } from "../models/nominals";
import { check } from "../models/utils";
import { ajax } from "../utils/ajax";
import { PromiseMutex } from "../utils/mutex";

/**
 * Return the UpsellInfoModal content for any bundles that are associated
 * with the given product ID.
 */
export const getUpsellInfoModalContent = async (
    triggeringProductID: IProductID,
): Promise<readonly IModularConfiguratorUpsellInfoModal[]> => {
    const unwrappedTriggeringProductID =
        isoProductID.unwrap(triggeringProductID);
    const mutex = new PromiseMutex<
        readonly IModularConfiguratorUpsellInfoModal[]
    >(`product-upsell-info-modals-get-${unwrappedTriggeringProductID}`);
    let loading = mutex.getPromise();
    if (!loading) {
        loading = ajax
            .get(
                reverse("product-upsellinfomodals", {
                    pk: unwrappedTriggeringProductID,
                }),
            )
            .set("Accept", "application/json")
            .then((resp) => {
                return check(
                    ModularConfiguratorUpsellInfoModals.decode(resp.body),
                );
            });
        mutex.setPromise(loading);
    }
    return loading;
};

/**
 * Return the UpsellInfoModal content for any bundles that are associated
 * with the given product ID.
 */
export const getPromoCards = async (
    triggeringProductID: IProductID,
): Promise<readonly IModularConfiguratorPromoCard[]> => {
    const unwrappedTriggeringProductID =
        isoProductID.unwrap(triggeringProductID);
    const mutex = new PromiseMutex<readonly IModularConfiguratorPromoCard[]>(
        `product-promo-cards-get-${unwrappedTriggeringProductID}`,
    );
    let loading = mutex.getPromise();
    if (!loading) {
        loading = ajax
            .get(
                reverse("product-promocards", {
                    pk: unwrappedTriggeringProductID,
                }),
            )
            .set("Accept", "application/json")
            .then((resp) => {
                return check(ModularConfiguratorPromoCards.decode(resp.body));
            });
        mutex.setPromise(loading);
    }
    return loading;
};
